import { DEFAULT_MEASURES_FILTERS, DEFAULT_TABS_AMOUNT } from '@/data/techAndMeasures';
import type { MeasureFilterData, TabAmount } from '@/types';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const PORTAL = 'techMeasures';

export const useTechMeasuresStore = defineStore(PORTAL, () => {
  const filtersData = ref(structuredClone(DEFAULT_MEASURES_FILTERS));

  const manufacturingProcessOption = ref('');

  const tabAmounts = ref(structuredClone(DEFAULT_TABS_AMOUNT));

  const measureFiltersData = computed(() => filtersData.value);

  const manufacturingProcess = computed(() => manufacturingProcessOption.value);

  const setFiltersData = (filters: MeasureFilterData) => (filtersData.value = filters);

  const setManufacturingProcess = (option: string) => (manufacturingProcessOption.value = option);

  const setTabsAmount = (newTabsAmount: TabAmount[]) => (tabAmounts.value = newTabsAmount);

  return {
    measureFiltersData,
    manufacturingProcess,
    setFiltersData,
    setManufacturingProcess,
    setTabsAmount,
    tabAmounts
  };
});
